<script>
import { layoutMethods,billsPaymentMethods,reportsMethods } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Topup Transaction Details",
  },
  data() {
    return {
        userId: 0,
        transactionId: 0,
        userDetails: {},
        transactionDetails: {},
    };
  },
  mounted: async function () {
    this.userId = this.$route.params.userId
    this.transactionId = this.$route.params.id
    this.changeTitle({ title: "Topup Transaction Details" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: 'Report', to: { name: 'Bills Payment Topup'} },
        { text: 'Bills Payment Topup', to: { name: 'Bills Payment Topup'} },
        { text: 'Details', to: { name: 'Bills Payment Topup Details'} }
      ],
    });
    this.getUserDetails();
    this.getTransactionDetails();
  },
  computed: {
  },
  methods: {
    ...layoutMethods,
    ...billsPaymentMethods,
    ...reportsMethods,
    getUserDetails(){
      this.actionBillsPayment({
          action: "user-info",
          body: {"user_id":this.userId}
      })
      .then((res) => {
        console.log(JSON.stringify(res));
        this.userDetails = res["message"][0];
      }).catch((e)=>{
        console.log("error while getting Details",e);
      });
    },
    getTransactionDetails(){
      this.actionBillsPayment({
          action: "transaction-info",
          body: {"id":this.transactionId}
      })
      .then((res) => {
        console.log(JSON.stringify(res));
        this.transactionDetails = res["message"][0];
        this.fetchTransactionDetails();
      }).catch((e)=>{
        console.log("error while getting Details",e);
      });
    },
    textCleaner(text = ""){
      var return_text = '--';
      if(text != null && text.length > 0){
        return_text = text;
      }
      try {
        if(!isNaN(parseInt(text))){
          return_text = text.toFixed(2);
        }
      } catch (error) {
        console.log(error);
      }
      return return_text;
    },
    fetchTransactionDetails() {
      this.fetchPaymongoTransaction({ transactionId: this.transactionDetails.trans_reference_no })
        .then((response) => {
          console.log("::paymongo::",JSON.stringify(response));
        this.transactionDetails = {...this.transactionDetails, data: response.attributes};
        })
        .catch((err) => {
          Swal.fire("Error!", `An error occured for fetching Paymongo Source Transaction: ${err}`, "error");
          console.log(err);
        });
    },
    propertyExist(obj,prop){
      return Object.prototype.hasOwnProperty.call(obj, prop)
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-3" v-if="propertyExist(userDetails,'customer_name')">
        <!-- Merchant Details card -->
        <div class="card">
          <div class="card-body">
            <div class="d-flex mb-3 border-bottom pb-2 text-dark">
              <div class="flex-grow-1 my-auto">
                <span class="align-middle fw-semibold">Merchant Details</span>
              </div>
            </div>
            <ul class="list-unstyled mb-0 mt-4">
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-user-circle"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.customer_name)}}</h5>
                  </div>
                </div>
              </li>
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-mobile-alt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Mobile Number</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.mobile_number)}}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-envelope"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Email</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.email)}}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-receipt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Business Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal bl">{{textCleaner(userDetails.business_name)}}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
            </ul>
          </div>
        </div>
        <!-- end Merchant Details card -->
      </div>
      <!-- end col -->

      <div class="col-xl-9">
        <div class="row">
          <div class="col-lg-12" v-if="propertyExist(transactionDetails,'trans_amount')">
            <!-- Transaction Details card -->
            <div class="card">
              <div class="card-body">
                <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                  <div class="flex-grow-1 my-auto">
                    <span class="align-middle fw-semibold">Transaction Details</span>
                  </div>
                </div>
                <div class="row">
                  <form>
                    <div class="row">
                      <div class="col-lg-8">
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Wallet:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">Bills Payment</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Payment Method:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{textCleaner(transactionDetails.payment_mode)}}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Amount:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">₱ {{textCleaner(transactionDetails.trans_amount) }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Service Fee:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">₱ {{textCleaner(transactionDetails.service_fee) }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Total Amount Paid:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">₱ {{textCleaner(transactionDetails.total_amount_paid) }}</p>
                            <!-- Total to Pay = topup amount + service fee -->
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Top-up Amount Value:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">₱ {{textCleaner(transactionDetails.trans_amount) }}</p>
                            <!-- Top-up Amount Value = topup amount + rebate -->
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Date:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{transactionDetails.trans_datetime | formatDate}}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Transaction ID:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{textCleaner(transactionDetails.trans_reference_no)}}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Error Description:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{textCleaner(transactionDetails.error_details)}}</p>
                          </div>
                        </div>
                        <div class="row m-b-9" v-if="propertyExist(transactionDetails,'data')">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Net Fee:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">₱ {{transactionDetails.data.net_amount != null ? (transactionDetails.data.net_amount / 100).toFixed(2) : '0.00' }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9" v-if="propertyExist(transactionDetails,'data')">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Fee:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">₱ {{ transactionDetails.data.fee != null ? (transactionDetails.data.fee / 100).toFixed(2) : '0.00' }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Status:</p>
                          </div>
                          <div class="col-8" v-if="propertyExist(transactionDetails,'data')">
                            <p class="font-size-13 text-uppercase"
                                :class="{
                                    'text-success': transactionDetails.status == 'success',
                                    'text-danger': transactionDetails.status == 'failed',
                                    'text-warning': transactionDetails.status == 'pending',
                                }">{{textCleaner(transactionDetails.data.status)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- hidden -->
                  </form>
                </div>
              </div>
            </div>
            <!-- end Transaction Details card -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
<style>
.bl{
  line-break: anywhere;
}
</style>